module.exports = __webpack_public_path__ + "static/media/4434.aa5598e3.jpg";